const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/community-lab/$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/community-lab/$")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});